export default __webpack_public_path__ + "static/media/dotPrimary.85c30245.svg";